var XPortal = XPortal || {};

XPortal.SearchBar = (function () {
    var self =
        {
            keepFocus: false,
            Init: function (selector, settingsObj) {
                $('.animated .btn-quick-search').on('click', function () {
                    var $parent = $(this).parent();
                    var $input = $(this).next();
                    if ($parent.hasClass('opened') && $input.val() != '') {
                        alert('do search');
                        return;
                    };

                    $parent.toggleClass('opened');

                    if ($parent.hasClass('opened')) {
                        $input.focus();
                    }
                });

                $('.animated .quick-search').blur(function () {
                    XPortal.SearchBar.keepFocus = false;
                    window.setTimeout(XPortal.SearchBar.hideList, 200);
                }).focus(function () {
                    XPortal.SearchBar.keepFocus = true;
                });
            },
            hideList: function() {
                if (!XPortal.SearchBar.keepFocus) {
                    $('.quick-search-container.animated').removeClass('opened');
                }
            }
       };

    return self;
}());
